import { FC } from 'react';
import { styled } from 'styled-components';
import { ISrc, ISrcUrl, decryptImgFn } from './helper';

interface IImage {
  src: ISrc | string;
  className?: string;
  style?: React.CSSProperties;
  onClick?: () => void;
  onLoad?: () => void;
}

const arePropsEqual = (prevProps: any, nextProps: any) => {
  return prevProps.src === nextProps.src;
};

const imageCacheMap = new Map();

const ImageWrap = styled.img``;

const Image: FC<IImage> = memo((props) => {
  const [decSrc, setDecSrc] = useState('');

  useEffect(() => {
    let tempSrc: ISrc | any = {
      // thumbnail: {
      //   key: '',
      //   url: '',
      // },
      // resource: {
      //   key: '',
      //   url: '',
      // },
    };

    if (typeof props.src === 'string') {
      try {
        tempSrc = JSON.parse(props.src);
      } catch (error) {
        return setDecSrc(props.src);
      }
    } else if (typeof props.src === 'object') {
      tempSrc = props.src;
    }

    let isBase64 = false;

    let temp: any;
    if (tempSrc?.thumbnail) {
      if (tempSrc?.thumbnail?.url) {
        temp = tempSrc.thumbnail;
      } else if (tempSrc?.thumbnail?.url !== '') {
        // maybe base64: thumbnail: "data:image/jpeg;base64"
        temp = tempSrc.thumbnail;
        isBase64 = true;
      } else {
        temp = tempSrc.resource;
      }
    } else {
      temp = tempSrc;
    }
    if (imageCacheMap.has(temp.url)) {
      setDecSrc(imageCacheMap.get(temp.url));
      return;
    }

    if (isBase64) {
      return;
    }

    decryptImgFn(temp).then((res: any) => {
      setDecSrc(res);
      imageCacheMap.set(temp.url, res);
    });
  }, [props.src]);

  return (
    <ImageWrap
      onLoad={() => props.onLoad?.()}
      onClick={() => props.onClick?.()}
      src={decSrc}
      className={props.className}
      style={props.style}
    ></ImageWrap>
  );
}, arePropsEqual);

export default Image;
